<template>
	<div id="app" >
		<okanGraph 
		ref="graphComponent"

		v-bind:okanMap="okanMap"
		v-show="okanMap.graphOpen" 

		v-on:save="graphSave"
		v-on:apply="graphApply"
		v-on:cancel="graphCancel"
		/>

		<colorPicker 
		ref="colorPicker"
		v-bind:initialColor="{r:255,g:0,b:0,a:1}"
		v-bind:okanMap="okanMap"
		v-show="okanMap.showColorPicker"

		v-on:save="colorSave"
		v-on:apply="colorApply"
		/>

		<div id="popupWindow"
		v-bind:class="{
			['open'] : okanMap.showPopup,
		}"
		v-on:click="okanMap.showPopup = false">
			<div id="popupWindow_inner">
				<div id="popupWindow_header" v-html="okanMap.popupTitle"></div>
				<div id="popupWindow_content" v-html="okanMap.popupHTML"></div>
			</div>
		</div>

		<mapLayer v-bind:okanMap="okanMap"/>
		
		<UI v-bind:okanMap="okanMap" />
	</div>
</template>

<script>
import UI from './components/UI.vue'
import mapLayer from './components/mapLayer.vue'
import OkanMap from './OkanMap.js';
import okanGraph from './components/ui/okanGraph.vue'
import colorPicker from './components/ui/colorPicker.vue'


export default {
	name: 'app',
	components: {
		UI,
		mapLayer,
		okanGraph,
		colorPicker
	},
	data: function() {
			return {
				okanMap: new OkanMap(),
			}
	},
	mounted() {

		this.okanMap.graphComponent = this.$refs.graphComponent;
		this.okanMap.colorPicker = this.$refs.colorPicker;
		
	},
	created() {
		
	},
	destroyed() {

	},
	methods : {
 
		init() {
		},

		graphApply(result){
			this.okanMap.applyGraph(result);
		},

		graphSave(result, graph){
			this.okanMap.applyGraph(result);
			this.okanMap.saveGraph(result, graph);
		},

		graphCancel(oldValue){
			console.log('cancel from app')
			this.okanMap.applyGraph(oldValue);
		},


		colorApply(color){
			this.okanMap.applyColor(color);
		},

		colorSave(color){
			this.okanMap.saveColor(color);
		}

	}
}
</script>

<style src="./assets/css/main.css"></style>
